@if (data) {
    <div class="infographic-wrapper {{data.classes}}">
        @if (data.headerData) {
            <finder-component-header
                [data]="data.headerData"
            ></finder-component-header>
        }
        @if (data.items.length) {
            <div class="infographic">
                @for (item of data.items; let index = $index; track index) {
                    <div class="infographic-item">
                        @if (item.picture) {
                            <!-- IMAGE -->
                            <div class="infographic-picture">
                                <finder-picture class="fit" [picture]="item.picture"></finder-picture>
                            </div>
                        }
                        @if (item.title || item.subtitle || item.link) {
                            <div class="infographic-text">
                                @if (item.title) {
                                    <!-- TITLE -->
                                    <h3 class="infographic-title" [innerHTML]="item.title | safeHtml"></h3>
                                }
                                @if (item.subtitle) {
                                    <!-- SUBTITLE -->
                                    <p class="infographic-subtitle" [innerHTML]="item.subtitle | safeHtml"></p>
                                }
                                @if (item.link) {
                                    <!-- LINK -->
                                    <p class="infographic-link">
                                        <a
                                            [href]="item.link.url"
                                            [attr.target]="item.link.target"
                                            [innerHTML]="item.link.text | safeHtml"
                                        ></a>
                                    </p>
                                }
                            </div>
                        }
                    </div>
                }
            </div>
        }
    </div>
}
